import { TExperienceData } from "./Experience";

const ExperienceTechs = ({
  techs,
}: Partial<Pick<TExperienceData, "techs">>) => {
  return (
    <div className="flex flex-wrap gap-0.5 md:gap-2 mt-1 lg:mt-6">
      {techs?.map((tech, i) => (
        <p
          className="p-1 md:p-2  bg-black/5 dark:bg-white/5 rounded-[5px] !text-xs lg:!text-sm shadow-sm backdrop-blur-2xl dark:hover:bg-white/30"
          key={i}
        >
          {tech}
        </p>
      ))}
    </div>
  );
};

export default ExperienceTechs;
